//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      shareList: [
        {
          name: '润工作',
          class: 'icon-border run-icon',
          icon: '',
          handler: this.shareRun,
        },
        {
          name: '复制链接',
          class: 'icon-border radius-box copy-link',
          icon: 'share-icon icon-link',
          handler: this.copyLink,
        },
      ],
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  methods: {
    shareRun() {
      if (this.$isHarmony) {
        new this.$Dialog({
          title: '温馨提示',
          text: `该功能暂不支持鸿蒙系统`,
          theme: 'ios',
          isConfirm: false
        });
        return;
      }
      let _this = this
      window.h5sdk.biz.util.share({
        url: this.item.mobileUrl,
        title: this.item.titleFormat,
        onSuccess: function (result) {},
      })
      // window.tt.share({
      //   channelType: [
      //     "wx",
      //     "wx_timeline",
      //     "system"
      //   ],
      //   contentType: "url",
      //   title: this.item.titleFormat,
      //   url: this.item.mobileUrl,
      //   success(res) {
      //     console.log(JSON.stringify(res));
      //   },
      //   fail(res) {
      //     console.log(`share fail: ${JSON.stringify(res)}`);
      //   }
      // });
      setTimeout(() => {
        _this.cancle()
      }, 500)
    },
    copyLink() {
      if (this.$isHarmony) {
        new this.$Dialog({
          title: '温馨提示',
          text: `该功能暂不支持鸿蒙系统`,
          theme: 'ios',
          isConfirm: false
        });
        return;
      }
      let _this = this
      window.h5sdk.biz.util.copyText({
        text: this.item.mobileUrl,
      })
      setTimeout(() => {
        _this.cancle()
      }, 500)
    },
    cancle() {
      this.$emit('popup-close')
    },
  },
}
